/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Subheader/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconWarning from 'DesignSystem/Svgs/TysiaIconWarning/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Subheader({
  children,
  viewPath = "/App/Account/NewPatient/Content/Panes/Check/Content/Patients/Subheader"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="Subheader.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z2sUFFf': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaIconWarning
  viewPath={`${viewPath}/TysiaIconWarning`}
 marginRight={dtSpaceXs}
 width={dtSpaceS}
 height={dtSpaceS}
 fill={dtColorsNeutral500}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 text="The patient you are about to register is similar to the following people already registered into the system. If one of these is the correct person, please select them instead. Otherwise, click None of the Above."
/>
</div>
{children}
</React.Fragment>)
}